import { Component, OnInit } from '@angular/core';
import { BankService } from '../../service/bank/bank.service';
import { Bank } from '../../class/bank';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-banks',
  templateUrl: './banks.component.html',
  styleUrls: ['./banks.component.scss']
})
export class BanksComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public banks: Bank[];
    public selectBank: Bank;
    public userID: Number = 0;
    public modNew = false;
    public modView = false;
    public openBank = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    constructor(
        public bankService: BankService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) { }

    ngOnInit() {
        this.getBanks();
        this.page = 1;
        this.per_page = 10;
    }

    public loadBanksLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        this.getBanks(event.globalFilter);
    }

    public getBanks(query?: string) {
        this.bankService.getBank(this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.banks = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newBank() {
        this.modNew = !this.modNew;
        this.selectBank = null;
    }

    public savedBank(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectBank = null;
        this.modNew = false;
        this.getBanks();
    }

    public cancelBank (res) {
        this.selectBank = null;
        this.modNew = false;
        this.modView = false;
        this.getBanks();
    }

    public edit(user: Bank) {
        this.modNew = true;
        this.selectBank = user;
        this.getBanks();
    }

    public view(user: Bank) {
        this.openBank = true;
        this.selectBank = user;
        this.userID = user.id;
        this.modView = true;
    }

    public deleteDialog(user: Bank) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(user);
            }
        });
    }

    public delete(user: Bank) {
        this.bankService.deleteBank(user.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getBanks();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeBank(user: Bank) {
        this.putBank(user);
    }

    public putBank(values: Bank) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.bankService.updateBank(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/banks/banks.component.ts